import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sellerinfosales',
  templateUrl: './sellerinfosales.component.html',
  styleUrls: ['./sellerinfosales.component.scss']
})
export class SellerinfosalesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
